export class DeliveryOptionModel {
    email: boolean;
    rssFeed: boolean;
    digest: boolean;
}
